export const FAST_LANE_API_URL = process.env.NEXT_PUBLIC_FAST_LANE_API_URL;
export const FAST_LANE_ROOT_URL =
  process.env.NEXT_PUBLIC_FAST_LANE_ROOT_URL || "https://fast-lane.site";
